import { render, staticRenderFns } from "./LessonContentCommon.vue?vue&type=template&id=193cf346&scoped=true"
import script from "./LessonContentCommon.vue?vue&type=script&lang=js"
export * from "./LessonContentCommon.vue?vue&type=script&lang=js"
import style0 from "./LessonContentCommon.vue?vue&type=style&index=0&id=193cf346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193cf346",
  null
  
)

export default component.exports